export default "__VITE_ASSET__BC_V9e9___"